export default __webpack_public_path__ + "static/media/lock.c1cf0248.svg";